import { createFileRoute } from '@tanstack/react-router';

import { Index } from './-components/Index';
import { IndexContext } from './-logic/IndexContext';
import { useIndex } from './-logic/useIndex';

export const Route = createFileRoute('/')({
  component: IndexPage,
});

function IndexPage() {
  return (
    <IndexContext.Provider value={useIndex()}>
      <Index />
    </IndexContext.Provider>
  );
}
